module.exports = __webpack_public_path__ + "img/membership-rewards-points.10a2ae23.jpg";